module.exports = "/images/kurdistan.svg?e7ce116c060ba0c259fe82244173ca9b";